<template>
  <div class="dictionary">
    <div class="dictionary__container">
      <div class="dictionary__content">
        <p-breadcrumb
          :items="[
            { label: $t('general.home'), to: '/' },
            { label: $t('general.dictionary'), to: appLink('dictionary') },
          ]"
          class="mb-20 mb-sm-40"
        />

        <p-content-title :title="`Paribu ${$t('general.dictionary')}`" :social-icons="[]" />

        <div class="dictionary-control py-24 my-32 my-sm-40">
          <p-segmented-control
            id="cat"
            v-model:selected-index="selectedLetter"
            v-model="selected"
            :items="control"
            :prefer-query-navigation="true"
            size="lg"
          />
        </div>

        <div v-for="group in displayGroups" :key="`dictionaryItemGroup--${group.letter}`">
          <dictionary-item-group :letter="group.letter" :items="group.items" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'

import { useDictionaryGroups } from '@/api/useDictionary'
import { useAppLink } from '@/composables/useAppLink'

const { appLink } = useAppLink()

const { groups, fetchDictionaryGroups } = useDictionaryGroups()

const control = ref<{ key: string; display: string; url?: string }[]>([])
const selected = ref('')
const selectedLetter = ref(0)
const currentLetter = computed(() => route.query.cat?.toString() || '')

const route = useRoute()

const displayGroups = computed(() => {
  const list = groups.value
  if (!Array.isArray(list)) return []
  const key = currentLetter.value
  if (!key) return list
  const upperKey = String(key).toUpperCase()
  return list.filter((g) => String(g.letter || '').toUpperCase() === upperKey)
})

watch(
  () => groups.value,
  (newVal) => {
    if (!Array.isArray(newVal)) return
    const isAll = !currentLetter.value
    if (isAll || control.value.length === 0) {
      control.value = [
        { key: '', display: $t('general.all'), url: route.path },
        ...newVal.map((group) => ({
          key: group.letter,
          display: group.letter,
          url: `${route.path}?cat=${group.letter}`,
        })),
      ]
    }

    const matchedIndex = newVal.findIndex((g) => g.letter === currentLetter.value)
    selectedLetter.value = matchedIndex >= 0 ? matchedIndex + 1 : 0
  },
  { immediate: true },
)

watch(
  () => currentLetter.value,
  (key) => {
    if (key) fetchDictionaryGroups(String(key))
    else fetchDictionaryGroups('')
  },
  { immediate: true },
)

definePageMeta({
  name: 'dictionary',
})
</script>
